import React, {Component} from 'react';
import {connect} from 'react-redux';
import {has} from 'lodash';
import {Table} from 'semantic-ui-react';
import {warranties} from '../../../../constants';
import {Actions} from '../../../../../common/actions';
import {enterKeyCode, tabKeyCode} from '../../../../../common/constants/keyCodes';
import {getTotalColumn, validateUnique, falsePrincipalPart} from '../../../../utils';
import FormWork from './form';
import DisplayData from './data';

const initialState = {
  'taskId': '',
  'hours': 0.0,
  'principalTask': false,
  'description': '',
  'total': 0.0,
  'flatDealer': 0.0,
  'flatTde': 0.0,
  'flatInternal': 0.0,
  'paycode': 0,
};

class Work extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...initialState,
    };
  }

  componentDidMount() {
    const {handleChangeForm, jobs} = this.props;
    if (jobs.length) {
      const updateAdminJobs = jobs.map((job) => {
        const newJob = {...job};
        if (!has(newJob, 'paycode')) {
          newJob.paycode = 0;
        }
        if (!has(newJob, 'flatDealer')) {
          newJob.flatDealer = 0.0;
        }
        if (newJob.flatTde && !newJob.total) {
          newJob.total = newJob.flatTde * warranties.hour_price;
        }
        return newJob;
      });
      handleChangeForm('jobs', updateAdminJobs);
    }
  }

  componentDidUpdate(prevProps) {
    const {job} = this.props;
    if (prevProps.job !== job && job.description !== '') {
      this.setState({
        'description': job.description,
      });
    }
  }

  handleAddItem = () => {
    const {handleChangeForm} = this.props;
    const {
      taskId,
      principalTask,
      description,
      paycode,
      hours,
      flatTde,
      flatInternal,
      flatDealer,
    } = this.state;
    const newJobs = [...this.props.jobs];
    const item = {
      taskId,
      paycode,
      hours,
      'principalTask': principalTask ? 'S' : 'N',
      'flatTde': +flatTde, 'flatInternal': +flatInternal, 'flatDealer': +flatDealer,
      description, 'total': +flatTde * warranties.hour_price,
    };

    if (validateUnique(newJobs, 'taskId', taskId)) {
      const jobs = principalTask ? falsePrincipalPart(newJobs, 'principalTask') : newJobs;
      jobs.push(item);

      const updateJobs = jobs.map((job) => ({...job, paycode}));
      this.setState({
        ...initialState,
      }, () => {
        handleChangeForm('jobs', updateJobs);
      });
    } else {
      this.props.addMessageBoxError(`El item ${taskId} ya se encuentra en la lista`);
    }
  }

  handleRemoveItem = (id) => {
    const {handleChangeForm} = this.props;
    const jobs = [...this.props.jobs].filter((item, idx) => idx !== id);
    handleChangeForm('jobs', jobs);
  }

  handleSelectionChange = (e, {value}) => {
    const {campaign} = this.props;
    const selectedOption = campaign.tasksArray.find((task) => task.taskId === value);

    this.setState({
      'taskId': selectedOption.taskId,
      'hours': 0,
      'flatTde': selectedOption.flatTde,
      'flatDealer': selectedOption.flatDealer,
      'description': selectedOption.description,
      'total': selectedOption.flatTde * warranties.hour_price,
      'flatInternal': 0.0,
      'paycode': 0,
    });
  };

  handleUpdatePrincipalWorks = (data, selectItem) => {
    const {jobs, handleChangeForm} = this.props;
    const updatePrincipalJobs = jobs.map((item) => {
      if (item.taskId === selectItem.taskId) {
        return {
          ...selectItem,
          'principalTask': data.checked ? 'S' : 'N',
        };
      }
      return {
        ...item,
        'principalTask': 'N',
      };
    });
    handleChangeForm('jobs', updatePrincipalJobs);
  }

  handleUpdatePaycode = (value) => {
    const {jobs, handleChangeForm} = this.props;
    const updatePrincipalJobs = jobs.map((item) => {
      return {
        ...item,
        'paycode': value,
      };
    });
    handleChangeForm('jobs', updatePrincipalJobs);
  }

  handleUpdateFlat = (field, value, selectItem) => {
    const {jobs, handleChangeForm} = this.props;
    const updatePrincipalJobs = jobs.map((item) => {
      if (item.taskId === selectItem.taskId) {
        const flatTdeValue = field === 'flatTde' ? value : selectItem.flatTde;
        return {
          ...selectItem,
          [field]: +value,
          'total': flatTdeValue * warranties.hour_price,
        };
      }
      return item;
    });
    handleChangeForm('jobs', updatePrincipalJobs);
  }

  handleKeyDown = (e) => {
    const {taskId} = this.state;
    if (e.keyCode === enterKeyCode || e.keyCode === tabKeyCode) {
      if (taskId.length > 1) {
        this.props.getWarrantyAdminJobById(taskId);
      }
    }
  }

  handleChange = (field, value) => {
    this.setState({
      [field]: value,
      'description': field === 'taskId' ? '' : this.state.description,
    });
  }

  render() {
    const {jobs, disabledBtns, loading, campaign, campaignFlag} = this.props;

    return (
      <div>
        <div className='warranty-container-table'>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Ope. Manual</Table.HeaderCell>
                <Table.HeaderCell>No. de Operación</Table.HeaderCell>
                <Table.HeaderCell>Descripción</Table.HeaderCell>
                <Table.HeaderCell>Flat Dealer</Table.HeaderCell>
                <Table.HeaderCell>Flat TDE</Table.HeaderCell>
                <Table.HeaderCell>Flat Internal</Table.HeaderCell>
                <Table.HeaderCell>Valor hora</Table.HeaderCell>
                <Table.HeaderCell>PayCode</Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {!disabledBtns && (
                <FormWork
                  handleChange={this.handleChange}
                  {...this.state}
                  handleAddItem={this.handleAddItem}
                  handleCheckBox={this.handleCheckBox}
                  handleKeyDown={this.handleKeyDown}
                  handleUpdateFlat={this.handleUpdateFlat}
                  handleSelectionChange={this.handleSelectionChange}
                  campaignTasks={campaign?.tasksArray}
                  campaignFlag={campaignFlag}
                  loading={loading}
                />
              )}
              {jobs.map((job, idx) => (
                <DisplayData
                  disabledBtns={disabledBtns}
                  key={idx}
                  item={job}
                  id={idx}
                  handleUpdatePrincipalWorks={this.handleUpdatePrincipalWorks}
                  handleUpdatePaycode={this.handleUpdatePaycode}
                  handleUpdateFlat={this.handleUpdateFlat}
                  handleRemoveItem={this.handleRemoveItem}
                />
              ))}
              <Table.Row className='warranty-table-footer'>
                <Table.Cell> </Table.Cell>
                <Table.Cell> </Table.Cell>
                <Table.Cell>SUBTOTAL</Table.Cell>
                <Table.Cell>{getTotalColumn(jobs, 'flatDealer')} </Table.Cell>
                <Table.Cell>{getTotalColumn(jobs, 'flatTde')} </Table.Cell>
                <Table.Cell>{getTotalColumn(jobs, 'flatInternal')} </Table.Cell>
                <Table.Cell>
                  {'$'}
                  {getTotalColumn(jobs, 'total')}
                </Table.Cell>
                <Table.Cell> </Table.Cell>
                <Table.Cell> </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'loading': state.warrantiesAdminCategories.loading,
    'job': state.warrantiesAdminCategories.job,
    'campaign': state.campaign.campaign,
  };
};
const {getWarrantyAdminJobById, addMessageBoxError} = Actions;

const mapDispatchToProps = {
  getWarrantyAdminJobById,
  addMessageBoxError,
};

export default connect(mapStateToProps, mapDispatchToProps)(Work);
